import React, { createContext, useContext, useState } from 'react';
import AlertDialog from '../components/common/AlertDialog';

const AlertDialogContext = createContext(null);

export const AlertDialogProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [onConfirmCallback, setOnConfirmCallback] = useState(null);
  const [showOkButton, setShowOkButton] = useState(true); // New state for button visibility

  const openAlertDialog = (msg, ttl = '', confirmCallback = null, showBtn = true) => {
    setMessage(msg);
    setTitle(ttl);
    setOnConfirmCallback(() => confirmCallback); // Store the callback
    setShowOkButton(showBtn); // Set button visibility
    setIsOpen(true);
  };

  const closeAlertDialog = () => {
    setIsOpen(false);
    setMessage('');
    setTitle('');
    setOnConfirmCallback(null); // Clear the callback
  };

  const handleConfirm = () => {
    if (onConfirmCallback) {
      onConfirmCallback();
    }
    closeAlertDialog();
  };

  return (
    <AlertDialogContext.Provider value={{ openAlertDialog }}>
      {children}
      <AlertDialog isOpen={isOpen} title={title} message={message} onClose={closeAlertDialog} onConfirm={handleConfirm} showOkButton={showOkButton} />
    </AlertDialogContext.Provider>
  );
};

export const useAlertDialog = () => {
  return useContext(AlertDialogContext);
};